import axios from 'axios'
import Vue from 'vue'

// 无需权限路由集合
export const whiteList = []

const codeMessage = {
  200: '服务器成功返回请求的数据',
  201: '新建或修改数据成功',
  202: '一个请求已经进入后台排队（异步任务）',
  204: '删除数据成功',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作',
  401: '用户没有权限（令牌、用户名、密码错误）',
  403: '用户得到授权，但是访问是被禁止的',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作',
  406: '最多允许导出3个月的数据，请重试！',
  // 406: '请求的格式不可得',
  410: '请求的资源被永久删除，且不会再得到的',
  422: '当创建一个对象时，发生一个验证错误',
  500: '服务器发生错误，请联系管理员',
  502: '网关错误',
  503: '服务不可用，服务器暂时过载或维护',
  504: '网关超时'
}

// 创建一个axios实例
const service = axios.create({
  baseURL: '',
  timeout: 30000, // 请求超时时间 默认30秒
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'X-company-domain': 'app',
    token: (typeof window !== 'undefined' && localStorage.getItem('userToken')) || ''
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 对响应数据做处理
    if (res.code === 6) {
      // logout()
      // Vue.prototype.$message({
      //   message: '未登录,请登录后再试',
      //   type: 'error',
      // })
    } else {
      return res
    }
  },
  error => {
    if (error.response) {
      const res = error.response
      if (res.status === 401) {
        logout()
      } else if (res.data.code === 400001) {
        return Promise.reject(error.response)
      } else if (res.data && res.data.reasonPhrase) {
        Vue.prototype.$message({ message: res.data.reasonPhrase, type: 'error' })
      } else {
        // Vue.prototype.$message({ message: codeMessage[res.status], type: 'error' })
      }
    }
    return Promise.reject(error)
  }
)

function logout() {}

export default service
